import { h } from 'preact';
export const Move = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "5 9 2 12 5 15" }),
        h("polyline", { points: "9 5 12 2 15 5" }),
        h("polyline", { points: "15 19 12 22 9 19" }),
        h("polyline", { points: "19 9 22 12 19 15" }),
        h("line", { x1: "2", y1: "12", x2: "22", y2: "12" }),
        h("line", { x1: "12", y1: "2", x2: "12", y2: "22" })));
};
//# sourceMappingURL=move.js.map